import { createAsyncThunk } from "@reduxjs/toolkit";
import { NATIONAL_STORE } from "../../../../common/utils/cart-util";
import { DiscountDetails, UpdatePromoCodePrams } from "../../../promo-code/interfaces/promo-code.interface";
import { StoreState } from "../../../../store/store.interface";
import { ActionStatus } from "../../../../common/constants/action-status";
import { isGuestCheckoutPage } from "../../../../common/environment";
import { getCartIdFromURL } from "../../../../common/constants/guest-checkout-api";
import { getCustomerToken } from "../../../customer/customer";
import {
  deletePromoCodeDiscountMagentoApiCall,
  deletePromoCodeDiscountMagentoApiCallGuestCheckout
} from "../../../promo-code/api/promo-code.apis";
import { updateSkipFreightCalculation, recalculateTax } from "../../../checkout/shop-checkout";
import { getShopCart } from "./get-shop-cart.thunk";

export const deletePromoCode = createAsyncThunk('shopCart/deletePromoCode', async ({storeCode = NATIONAL_STORE, skipCalculation = false}: UpdatePromoCodePrams, thunkAPI) => {
  const state = thunkAPI.getState() as StoreState;

  let discountDetails: DiscountDetails | undefined = undefined;
  try {
    if (isGuestCheckoutPage()) {
      discountDetails = await deletePromoCodeDiscountMagentoApiCallGuestCheckout(getCartIdFromURL());
    } else {
      const customerToken = getCustomerToken(state);
      discountDetails = await deletePromoCodeDiscountMagentoApiCall(customerToken);
      discountDetails.coupon = '';
    }

    if (!skipCalculation) {
      thunkAPI.dispatch(updateSkipFreightCalculation(false));
      
      await thunkAPI.dispatch(getShopCart({
        forceUpdate: true,
        promoCode: '',
        store: storeCode
      })).unwrap();
      await recalculateTax(state, '', thunkAPI);
    }

    return discountDetails;
  } catch (error) {
    // if promocode is invalid updating estimated price without the discount.
    await thunkAPI.dispatch(getShopCart({
      forceUpdate: true,
      promoCode: '',
      store: storeCode
    })).unwrap();
    await recalculateTax(state, '', thunkAPI);

    return thunkAPI.rejectWithValue({
      promoCode: '',
      message: error
    });
  }
}, {
  condition: (({promoCode, forceUpdate}: UpdatePromoCodePrams, {getState}) => {
    const state = getState() as StoreState;
    return (state.promoCodeDiscountState.updatePromoCode.status !== ActionStatus.loading && promoCode !== state.promoCodeDiscountState.updatePromoCode.data?.coupon) || forceUpdate;
  })
});
